'use strict';

/**
 * group-bulk-assign — pure payload/query builders for the Groups bulk
 * "Assign app" / "Add to playlist" actions (groups.js assignApp /
 * addToPlaylist / updateAllGroups, ~line 112-225).
 *
 * Extracted so the mutation payload sent to Group.updateAll can be tested
 * directly without instantiating the Angular controller (this repo's
 * convention for controllers wired up via `.component(...)` — see
 * limit-controls.js / edit-app-connect.js).
 */

/**
 * Builds the `data` payload for the bulk "assign app" action.
 *
 * Assigning an app to a group must clear any playlistId already on the
 * group — a group can only be driving one or the other at a time. Omitting
 * playlistId here would leave a stale playlistId on the backend record
 * alongside the newly-assigned appId (the same class of stale-field bug
 * fixed for displays in PR #623).
 */
function buildAssignAppPayload(appId) {
    return { playlistId: null, appId };
}

/**
 * Builds the `data` payload for the bulk "add to playlist" action.
 *
 * Mirror of buildAssignAppPayload: assigning a playlist must clear any
 * appId already on the group.
 */
function buildAddToPlaylistPayload(playlistId) {
    return { appId: null, playlistId };
}

/**
 * Builds the loopback `where` query used to scope Group.updateAll() to only
 * the currently-selected groups. selectedGroupsIds must already be the
 * filtered list of ids (groups with `selected: true`).
 */
function buildSelectedGroupsQuery(selectedGroupsIds) {
    return {
        where: { id: { inq: selectedGroupsIds } },
    };
}

var groupBulkAssign = {
    buildAssignAppPayload: buildAssignAppPayload,
    buildAddToPlaylistPayload: buildAddToPlaylistPayload,
    buildSelectedGroupsQuery: buildSelectedGroupsQuery,
};

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = groupBulkAssign;
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('groupBulkAssign', groupBulkAssign);
}
